import nursingApi from '@/api/consultations/_nursing-station'
import stockApi from '@/api/_stock-laboratoire'
import { chargerFuseauStock, dateStock, fuseauStock } from '@/utils/stock-dates'
import { CATEGORIES_LABORATOIRE, CATEGORIES_HOSPITALISATION, familleArticle, sectionsArticles } from './stock-categories'

export default {
    name: 'service-stock',
    data() {
        return {
            services: [], service_id: null, articles: [], stock_code: '', stock_nom: '',
            echanges: [], sorties: [], chargement: false, erreur: '', recherche: '',
            filtre_categorie: '', filtre_etat: '', onglet: 'articles', sequence: 0
        }
    },
    computed: {
        service() { return this.services.find(item => Number(item.id) === Number(this.service_id)) || null },
        laboratoire() { return this.stock_code === 'laboratoire' },
        articles_filtres() {
            const terme = this.recherche.trim().toLocaleLowerCase('fr')
            return this.articles.filter(article =>
                (!terme || String(article.libelle || '').toLocaleLowerCase('fr').includes(terme))
                && (!this.filtre_etat || article.etat === this.filtre_etat))
        },
        categories() { return this.laboratoire ? CATEGORIES_LABORATOIRE : CATEGORIES_HOSPITALISATION },
        cartes() { return sectionsArticles(this.articles_filtres, this.categories)
            .filter(carte => !this.filtre_categorie || carte.id === this.filtre_categorie) },
        compteurs() { return { total: this.articles.length,
            rupture: this.articles.filter(article => article.etat === 'rupture').length,
            bas: this.articles.filter(article => article.etat === 'bas').length } },
        fuseau_horaire() { return fuseauStock(this.$store) },
        echanges_recus() { return this.echanges.filter(echange => Number(echange.type) === 1) },
        onglets() { return [
            { id: 'articles', nom: 'Articles', compte: this.articles.length },
            { id: 'recus', nom: this.service && this.service.uses_central_pharmacy ? 'Transferts reçus' : 'Reçus de la Pharmacie', compte: this.echanges_recus.length },
            { id: 'consommations', nom: 'Consommations', compte: this.sorties.length }
        ] },
        dernier_transfert() { return this.echanges_recus.length ? this.date_stock(this.echanges_recus[0]) : '' }
    },
    mounted() { this.charger() },
    beforeDestroy() { this.sequence++ },
    methods: {
        date_stock(evenement) { return dateStock(evenement, this.fuseau_horaire) },
        ouvrir_article(article) {
            if (!this.service || !this.service.stock_id) return
            this.$router.push({ name: 'Détail du produit du service',
                params: { stockId: this.service.stock_id, articleId: article.id } })
        },
        libelle_etat(etat) { return { rupture: 'En rupture', bas: 'Sous le seuil', ok: 'Disponible' }[etat] || '—' },
        classe_etat(etat) { return { rupture: 'badge-danger', bas: 'badge-warning', ok: 'badge-success' }[etat] || '' },
        async charger() {
            const sequence = ++this.sequence
            this.chargement = true
            this.erreur = ''
            try {
                const [reponse] = await Promise.all([nursingApi.myServices(), chargerFuseauStock(this.$store)])
                if (sequence !== this.sequence) return
                if (!reponse || reponse.success !== true || !Array.isArray(reponse.data)) throw new Error('Services indisponibles')
                this.services = reponse.data
                if (!this.service || !this.service.stock_id) {
                    const premier = this.services.find(item => item.is_primary && item.stock_id)
                        || this.services.find(item => item.stock_id)
                    this.service_id = premier ? premier.id : null
                }
                await this.charger_articles(sequence)
            } catch (error) {
                if (sequence === this.sequence) {
                    this.articles = []
                    this.erreur = 'Impossible de charger vos services ou leur stock. Réessayez.'
                }
            } finally {
                if (sequence === this.sequence) this.chargement = false
            }
        },
        async choisir_service() {
            const sequence = ++this.sequence
            this.chargement = true
            this.erreur = ''
            this.filtre_categorie = ''
            try { await this.charger_articles(sequence) }
            catch (error) {
                if (sequence === this.sequence) {
                    this.articles = []
                    this.erreur = 'Impossible de charger le stock de ce service. Réessayez.'
                }
            } finally { if (sequence === this.sequence) this.chargement = false }
        },
        async charger_articles(sequence) {
            this.articles = []
            this.stock_code = ''
            this.stock_nom = ''
            this.echanges = []
            this.sorties = []
            if (!this.service || !this.service.stock_id) return
            const [stock, echanges] = await Promise.all([
                stockApi.stock(this.service.stock_id), stockApi.echanges(this.service.stock_id).catch(error => {
                    // Les transferts sont réservés aux opérateurs du stock ; les soignants consultent les articles et sorties.
                    if (error.response && error.response.status === 403) return []
                    throw error
                })
            ])
            if (sequence !== this.sequence) return
            if (!stock || !Array.isArray(stock.articles)) throw new Error('Stock indisponible')
            this.stock_code = stock.code || ''
            this.stock_nom = stock.nom || this.service.name
            this.articles = stock.articles.map(article => ({
                ...article, quantite: Number(article.quantite) || 0,
                minimum: Number(article.minimum) || 0,
                famille: familleArticle(article),
                etat: Number(article.quantite) <= 0 ? 'rupture' :
                    (Number(article.minimum) > 0 && Number(article.quantite) <= Number(article.minimum) ? 'bas' : 'ok')
            }))
            this.echanges = (Array.isArray(echanges) ? echanges : []).slice().reverse()
            this.sorties = (Array.isArray(stock.sorties) ? stock.sorties : []).slice().reverse()
        }
    }
}
